// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================
   SIDEBAR
===================================== */

.admin-sidebar {
    position: fixed;
  
    top: 0;
    left: 0;
  
    width: 260px;
    height: 100vh;
    height: 100dvh;
  
    background: #ffffff;
  
    border-right:
      1px solid #e8eaf0;
  
    display: flex;
    flex-direction: column;
  
    z-index: 1200;
  
    box-sizing: border-box;
  
    transition:
      transform 0.25s ease;
  }
  
  
  /* =====================================
     HEADER
  ===================================== */
  
  .admin-sidebar-header {
    min-height: 94px;
  
    padding: 24px;
  
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  
    border-bottom:
      1px solid #eef0f4;
  
    box-sizing: border-box;
  }
  
  
  .admin-sidebar-header h2 {
    margin: 0;
  
    font-size: 24px;
    font-weight: 700;
  
    color: #111827;
  }
  
  
  .admin-sidebar-header span {
    display: block;
  
    margin-top: 5px;
  
    font-size: 13px;
  
    color: #8a94a6;
  }
  
  
  /* =====================================
     CLOSE BUTTON
  ===================================== */
  
  .admin-sidebar-close {
    display: none;
  
    width: 38px;
    height: 38px;
  
    align-items: center;
    justify-content: center;
  
    flex-shrink: 0;
  
    border: none;
    border-radius: 9px;
  
    background: #f2f4f7;
  
    color: #475467;
  
    font-size: 16px;
  
    cursor: pointer;
  }
  
  
  /* =====================================
     NAV
  ===================================== */
  
  .admin-sidebar-nav {
    flex: 1 1;
  
    padding: 20px 14px;
  
    overflow-y: auto;
  }
  
  
  .admin-sidebar-link {
    display: flex;
    align-items: center;
    gap: 12px;
  
    padding: 13px 14px;
  
    border-radius: 10px;
  
    text-decoration: none;
  
    font-size: 14px;
    font-weight: 500;
  
    color: #667085;
  
    transition:
      background 0.2s ease,
      color 0.2s ease;
  }
  
  
  .admin-sidebar-link svg {
    flex-shrink: 0;
  
    font-size: 16px;
  }
  
  
  .admin-sidebar-link:hover {
    background: #f4f6fa;
  
    color: #111827;
  }
  
  
  .admin-sidebar-link.active {
    background: #eef2ff;
  
    color: #4f46e5;
  }
  
  
  /* =====================================
     MOBILE / TABLET
  ===================================== */
  
  @media (max-width: 900px) {
  
    .admin-sidebar {
      width: min(
        300px,
        86vw
      );
  
      transform:
        translateX(-100%);
  
      box-shadow:
        18px 0 45px
        rgba(15, 23, 42, 0.18);
    }
  
  
    .admin-sidebar.open {
      transform:
        translateX(0);
    }
  
  
    .admin-sidebar-close {
      display: flex;
    }
  
  }
  
  
  /* =====================================
     VERY SMALL MOBILE
  ===================================== */
  
  @media (max-width: 380px) {
  
    .admin-sidebar {
      width: 88vw;
    }
  
  
    .admin-sidebar-header {
      padding: 20px 16px;
    }
  
  
    .admin-sidebar-nav {
      padding:
        16px 10px;
    }
  
  }`, "",{"version":3,"sources":["webpack://./src/admin/styles/AdminSidebar.css"],"names":[],"mappings":"AAAA;;uCAEuC;;AAEvC;IACI,eAAe;;IAEf,MAAM;IACN,OAAO;;IAEP,YAAY;IACZ,aAAa;IACb,cAAc;;IAEd,mBAAmB;;IAEnB;uBACmB;;IAEnB,aAAa;IACb,sBAAsB;;IAEtB,aAAa;;IAEb,sBAAsB;;IAEtB;0BACsB;EACxB;;;EAGA;;yCAEuC;;EAEvC;IACE,gBAAgB;;IAEhB,aAAa;;IAEb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;;IAET;uBACmB;;IAEnB,sBAAsB;EACxB;;;EAGA;IACE,SAAS;;IAET,eAAe;IACf,gBAAgB;;IAEhB,cAAc;EAChB;;;EAGA;IACE,cAAc;;IAEd,eAAe;;IAEf,eAAe;;IAEf,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;IACE,aAAa;;IAEb,WAAW;IACX,YAAY;;IAEZ,mBAAmB;IACnB,uBAAuB;;IAEvB,cAAc;;IAEd,YAAY;IACZ,kBAAkB;;IAElB,mBAAmB;;IAEnB,cAAc;;IAEd,eAAe;;IAEf,eAAe;EACjB;;;EAGA;;yCAEuC;;EAEvC;IACE,SAAO;;IAEP,kBAAkB;;IAElB,gBAAgB;EAClB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET,kBAAkB;;IAElB,mBAAmB;;IAEnB,qBAAqB;;IAErB,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd;;qBAEiB;EACnB;;;EAGA;IACE,cAAc;;IAEd,eAAe;EACjB;;;EAGA;IACE,mBAAmB;;IAEnB,cAAc;EAChB;;;EAGA;IACE,mBAAmB;;IAEnB,cAAc;EAChB;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE;;;OAGC;;MAED;yBACmB;;MAEnB;;8BAEwB;IAC1B;;;IAGA;MACE;qBACe;IACjB;;;IAGA;MACE,aAAa;IACf;;EAEF;;;EAGA;;yCAEuC;;EAEvC;;IAEE;MACE,WAAW;IACb;;;IAGA;MACE,kBAAkB;IACpB;;;IAGA;MACE;iBACW;IACb;;EAEF","sourcesContent":["/* =====================================\n   SIDEBAR\n===================================== */\n\n.admin-sidebar {\n    position: fixed;\n  \n    top: 0;\n    left: 0;\n  \n    width: 260px;\n    height: 100vh;\n    height: 100dvh;\n  \n    background: #ffffff;\n  \n    border-right:\n      1px solid #e8eaf0;\n  \n    display: flex;\n    flex-direction: column;\n  \n    z-index: 1200;\n  \n    box-sizing: border-box;\n  \n    transition:\n      transform 0.25s ease;\n  }\n  \n  \n  /* =====================================\n     HEADER\n  ===================================== */\n  \n  .admin-sidebar-header {\n    min-height: 94px;\n  \n    padding: 24px;\n  \n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  \n    border-bottom:\n      1px solid #eef0f4;\n  \n    box-sizing: border-box;\n  }\n  \n  \n  .admin-sidebar-header h2 {\n    margin: 0;\n  \n    font-size: 24px;\n    font-weight: 700;\n  \n    color: #111827;\n  }\n  \n  \n  .admin-sidebar-header span {\n    display: block;\n  \n    margin-top: 5px;\n  \n    font-size: 13px;\n  \n    color: #8a94a6;\n  }\n  \n  \n  /* =====================================\n     CLOSE BUTTON\n  ===================================== */\n  \n  .admin-sidebar-close {\n    display: none;\n  \n    width: 38px;\n    height: 38px;\n  \n    align-items: center;\n    justify-content: center;\n  \n    flex-shrink: 0;\n  \n    border: none;\n    border-radius: 9px;\n  \n    background: #f2f4f7;\n  \n    color: #475467;\n  \n    font-size: 16px;\n  \n    cursor: pointer;\n  }\n  \n  \n  /* =====================================\n     NAV\n  ===================================== */\n  \n  .admin-sidebar-nav {\n    flex: 1;\n  \n    padding: 20px 14px;\n  \n    overflow-y: auto;\n  }\n  \n  \n  .admin-sidebar-link {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  \n    padding: 13px 14px;\n  \n    border-radius: 10px;\n  \n    text-decoration: none;\n  \n    font-size: 14px;\n    font-weight: 500;\n  \n    color: #667085;\n  \n    transition:\n      background 0.2s ease,\n      color 0.2s ease;\n  }\n  \n  \n  .admin-sidebar-link svg {\n    flex-shrink: 0;\n  \n    font-size: 16px;\n  }\n  \n  \n  .admin-sidebar-link:hover {\n    background: #f4f6fa;\n  \n    color: #111827;\n  }\n  \n  \n  .admin-sidebar-link.active {\n    background: #eef2ff;\n  \n    color: #4f46e5;\n  }\n  \n  \n  /* =====================================\n     MOBILE / TABLET\n  ===================================== */\n  \n  @media (max-width: 900px) {\n  \n    .admin-sidebar {\n      width: min(\n        300px,\n        86vw\n      );\n  \n      transform:\n        translateX(-100%);\n  \n      box-shadow:\n        18px 0 45px\n        rgba(15, 23, 42, 0.18);\n    }\n  \n  \n    .admin-sidebar.open {\n      transform:\n        translateX(0);\n    }\n  \n  \n    .admin-sidebar-close {\n      display: flex;\n    }\n  \n  }\n  \n  \n  /* =====================================\n     VERY SMALL MOBILE\n  ===================================== */\n  \n  @media (max-width: 380px) {\n  \n    .admin-sidebar {\n      width: 88vw;\n    }\n  \n  \n    .admin-sidebar-header {\n      padding: 20px 16px;\n    }\n  \n  \n    .admin-sidebar-nav {\n      padding:\n        16px 10px;\n    }\n  \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
